import { render } from "./CompanySettingsView.vue?vue&type=template&id=dacb04c6&ts=true"
import script from "./CompanySettingsView.vue?vue&type=script&lang=ts"
export * from "./CompanySettingsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__